<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="搜索名称" />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select
                v-model="queryParam.status"
                placeholder="请选择"
                allowClear
              >
                <a-select-option value="1">进行中</a-select-option>
                <a-select-option value="3">未开始</a-select-option>
                <a-select-option value="4">已结束</a-select-option>
                <a-select-option value="2">已下架</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="(!advanced && 6) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="
                (advanced && { float: 'right', overflow: 'hidden' }) || {}
              "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="() => (queryParam = {})"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="setAllStatus(1)" key="1"
            ><a-icon type="upload" />上架</a-menu-item
          >
          <a-menu-item @click="setAllStatus(2)" key="2"
            ><a-icon type="download" />下架</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{
        show: true,
        clear: () => {
          this.selectedRowKeys = [];
        },
      }"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
      <span slot="title1" slot-scope="text, record">
        <div style="margin-bottom: 10px">{{ record.title }}</div>
      </span>

      <span slot="timeRange" slot-scope="text, record">
        <template>
          <div>
            开始:{{ record.time_start | timeFormat }}<br />
            结束:{{ record.time_end | timeFormat }}
          </div>
        </template>
      </span>
      <span slot="orderCount" slot-scope="text, record">
        <template>
          <div>{{ record.order_count }}/{{ record.complete_count }}</div>
        </template>
      </span>
      <span slot="rank" slot-scope="text, record">
        <template>
          <editable-cell
            :text="text"
            @change="onRankChange(record.id, 'rank', $event)"
          />
        </template>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleOrderList(record)">商品清单</a>
          <a-divider type="vertical" />
          <a @click="handleShare(record)">分享</a>
          <a-divider type="vertical" />
          <a @click="handleUserManage(record)">订单记录</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="删除后不可恢复,确定删除吗?"
            @confirm="deleteHandle(record)"
            okText="确定"
            cancelText="取消"
          >
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>

    <a-modal
      :maskClosable="false"
      title="操作"
      :width="1000"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="visible"
      @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-divider>基础配置</a-divider>

          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="配置名称"
            hasFeedback
          >
            <a-input
              v-decorator="[
                'title',
                { rules: [{ required: true, message: '请输入标题' }] },
              ]"
              placeholder="请输入标题"
            />
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="活动时间"
            hasFeedback
          >
            <a-range-picker
              v-model="formData.time_range_moment"
              :showTime="{
                defaultValue: [
                  moment('00:00:00', 'HH:mm:ss'),
                  moment('23:59:59', 'HH:mm:ss'),
                ],
              }"
              format="YYYY-MM-DD HH:mm:ss"
            />
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="团队人数"
            hasFeedback
          >
            <a-input
              tyoe="number"
              v-decorator="[
                'complete_count',
                { rules: [{ required: true, message: '请输入人数' }] },
              ]"
              placeholder="请输入人数"
            />
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="团队购买时限"
            hasFeedback
            extra="限多少小时内可下单有效"
          >
            <a-input
              tyoe="number"
              v-decorator="[
                'time_limit',
                { rules: [{ required: true, message: '请输入小时数' }] },
              ]"
              placeholder="请输入小时数"
            />
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="推荐人"
            hasFeedback
          > 
            <div style="width:300px">
                  <span v-if="formData.id && formData.recommend_user_id && formData.recommend_user_name">{{formData.recommend_user_name}} <a-icon @click="()=>(formData.recommend_user_id=0,formData.recommend_user_name='')" type="form" /></span>
                  <user-picker v-else  style="width: 300px;margin-right: 10px;" :formData="formData" field="recommend_user_id" />
                </div>
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="状态"
            hasFeedback
          >
            <a-switch
              checkedChildren="上架"
              v-model="formData.status"
              unCheckedChildren="下架"
            />
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="是否包邮"
            hasFeedback
          >
            <a-switch
              checkedChildren="包邮"
              v-model="formData.express_free_status"
              unCheckedChildren="不包邮"
            />
          </a-form-item>
          <a-divider>地址配置</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="收件人"
                hasFeedback
              >
                <a-input
                  v-decorator="['express_user_name', { rules: [] }]"
                  placeholder="请输入收件人姓名"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="收件人手机"
                hasFeedback
              >
                <a-input
                  v-decorator="['express_user_phone', { rules: [] }]"
                  placeholder="请输入收件人手机"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="省市区选择"
                hasFeedback
              >
                <a-cascader
                  :options="areaOptions"
                  placeholder="请选择地区"
                  v-model="formData.areas"
                  changeOnSelect
                  @change="onAreaChange"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="具体地址"
                hasFeedback
              >
                <a-input
                  v-decorator="['address', { rules: [] }]"
                  placeholder="具体到街道门牌号"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button
          key="forward"
          :loading="saveLoading"
          type="primary"
          @click="handleOk"
          >保存</a-button
        >
      </template>
    </a-modal>

    <a-modal
      title="清单详情"
      :width="1200"
      v-model="orderVisible"
      @ok="orderVisible = false"
    >
      <a-button
        class="editable-add-btn"
        style="margin-bottom: 10px"
        @click="handleOrderAdd"
      >
        新增商品
      </a-button>
      <a-table bordered :data-source="orderData" :columns="orderColumns">
        <!-- <template slot="name" slot-scope="text, record">
        <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
      </template> -->

        <template slot="orderOption" slot-scope="text, record">
          <a-popconfirm title="确定删除吗?" @confirm="() => onDelete(record)">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a @click="handleOrderEdit(record)">编辑</a>
        </template>
      </a-table>
    </a-modal>
    <a-modal
      title="清单商品"
      :width="1000"
      v-model="orderAddVisible"
      @ok="orderAddVisible = false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="清单商品"
            hasFeedback
          >
            <a-select
              showSearch
              v-model="goodsData.goods_id"
              optionFilterProp="title"
              style="width: 300px"
              :disabled="goodsData.id > 0"
              @change="goodsChange"
              placeholder="选择商品"
            >
              <a-select-option
                :key="option.id"
                v-for="option in goodsOptions"
                :title="option.title"
                :disabled="option.disabled"
                :value="option.id"
              >
                <div
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  <img
                    style="height: 30px; width: 30px"
                    :src="option.pic_url"
                    alt=""
                    srcset=""
                  />
                  <span>{{ option.title }}</span>
                </div>
              </a-select-option>
            </a-select>
            <a
              href="javascript:;"
              @click="handleUrl()"
              v-if="goodsData.goods_id > 0"
              style="margin-left: 5px"
              >查看详情</a
            >
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="商品规格"
            hasFeedback
          >
            <sku-picker
              v-if="sku_show"
              @onSkuChecked="onSkuChecked"
              :sku_data="goods_sku"
              :sku_id="goodsData.sku_id"
              :sku_name="goodsData.sku_name"
            />
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="数量"
            hasFeedback
          >
            <a-input-number
              style="width: 288px"
              v-model="goodsData.goods_count"
              :min="1"
              :max="9999"
            />
          </a-form-item>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="单价"
            hasFeedback
          >
            <a-input-number
              style="width: 288px"
              v-model="goodsData.goods_price"
              :min="1"
              :max="99999999"
            />
          </a-form-item>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleGoodsCancel">取消</a-button>
        <a-button
          key="forward"
          :loading="saveLoading"
          type="primary"
          @click="handleGoodsOk"
          >保存</a-button
        >
      </template>
    </a-modal>

    <a-modal title="分享" v-model="h5ShareVisible" @ok="h5ShareVisible = false">
      <p style="text-align: center">
        <img :src="share.wxmini_pic_url" />
      </p>
      <p>{{ share.site_url }}</p>
      <a
        v-clipboard:copy="share.site_url"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        >点此复制</a
      >
    </a-modal>
    <a-modal
      :maskClosable="false"
      title="订单记录"
      :width="1000"
      style="top: 20px"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="userVisible"
      @ok="userVisible = false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table
            :columns="userColumns"
            :dataSource="saleUserList"
            :pagination="userPagination"
            @change="handleUserTableChange"
            rowKey="id"
            :scroll="{ y: 300 }"
            bordered
          >
            <div
              slot="filterDropdown"
              slot-scope="{
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
                column,
              }"
              class="custom-filter-dropdown"
            >
              <a-input
                v-model="userQuery.keywords"
                placeholder="搜索用户名/手机号"
                style="width: 188px; margin-bottom: 8px; display: block"
              />
              <a-button
                type="primary"
                @click="userSearch(selectedKeys, confirm)"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                >搜索</a-button
              >
              <a-button
                @click="userSearchReset(selectedKeys, confirm)"
                size="small"
                style="width: 90px"
                >重置</a-button
              >
            </div>
            <span slot="name" slot-scope="text, record">
              {{ record.user_name }}
            </span>
            <span slot="status2" slot-scope="text, record">
              {{ record.order_status.name }}
            </span>
            <span slot="order2" slot-scope="text, record">
              <a @click="handleOrderDetail(record)">查看</a>
            </span>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>
  </a-card>
</template>

<script>
import STable from "@/components/table/";
import ATextarea from "ant-design-vue/es/input/TextArea";
import AInput from "ant-design-vue/es/input/Input";
import EditableCell from "@/components/EditableCell/";
import PriceInput from "@/components/PriceInput/";
import SkuPicker from "@/components/SkuPicker/";
import UserPicker from '@/components/UserPicker/'

import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");

import areaOptions from "@/utils/area";
import {
  getGoodsOptions,
  getSaleList,
  getGoodsSkuDetail,
  addSale,
  editSale,
  saleDetail,
  setTuanRank,
  deleteTuan,
  setTuanAllStatus,
  getSaleUserList,
  saleGoodsEdit,
  saleGoodsAdd,
  saleGoodsList,
  saleGoodsDetail,
  saleGoodsDelete,
  saleDelete,
} from "@/api/purchase";
export default {
  name: "ConfigureList",
  components: {
    AInput,
    ATextarea,
    STable,
    EditableCell,
    PriceInput,
    SkuPicker,
    UserPicker
  },
  data() {
    return {
      areaOptions,
      orderData: [],
      goods_sku: {},
      goodsData: {
        sale_id: 0,
        goods_id: "",
        goods_name: "",
        sku_name: "",
        sku_id: 0,
        goods_count: 0,
        goods_price: 0,
        express_free_status: false,
      },
      visible: false,
      userVisible: false,
      areaVisible: false,
      saveLoading: false,
      h5ShareVisible: false,
      share: {
        wxmini_pic_url: "",
        site_url: "",
      },
      formData: {
        id: 0,
        title: "",
        areas: [],
        express_user_name: "",
        express_user_phone: "",
        express_province: "",
        express_city: "",
        express_county: "",
        address: "",
        time_range_moment: [],
        time_range: [],
        complete_count: 1,
        time_limit: 24, 
        recommend_user_id:'',
        recommend_user_name:'',
        auto_complete: true,
        status: true,
        express_free_status: false,
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: "",
      },
      cateOptions: [],
      // 表头
      columns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
        },
        {
          title: "套餐名称",
          dataIndex: "title",
          scopedSlots: { customRender: "title1" },
        },
        {
          width: "250px",
          title: "活动时间",
          dataIndex: "time_start",
          scopedSlots: { customRender: "timeRange" },
        },
        {
          title: "购买/订单",
          width: "100px",
          dataIndex: "order_count",
          scopedSlots: { customRender: "orderCount" },
        },

        {
          title: "操作",
          dataIndex: "action",
          width: "180px",
          scopedSlots: { customRender: "action" },
        },
      ],
      orderAddVisible: false,
      orderVisible: false,
      orderColumns: [
        {
          title: "销售商品名",
          dataIndex: "goods_name",
          width: "200px",
          scopedSlots: { customRender: "goods_name" },
        },
        {
          title: "规格",
          width: "100px",
          dataIndex: "sku_name",
        },
        {
          title: "单价",
          width: "100px",
          dataIndex: "goods_price",
        },
        {
          title: "数量",
          width: "100px",
          dataIndex: "goods_count",
        },

        {
          title: "操作",
          width: "200px",
          dataIndex: "orderOption",
          scopedSlots: { customRender: "orderOption" },
        },
      ],

      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        console.log("loadData");
        console.log(this.queryParam);
        this.queryParam.cate_id = 0;
        if (this.queryParam.cate_ids && this.queryParam.cate_ids.length) {
          this.queryParam.cate_id = [...this.queryParam.cate_ids].pop();
        }
        this.queryParam = Object.assign(parameter, this.queryParam);
        return getSaleList(this.queryParam).then((res) => {
          console.log("res");
          return res.data;
        });
      },
      selectedRowKeys: [],
      selectedRows: [],
      goodsOptions: [],
      sku_fields_list: [],

      skuTable: {
        sku_fields_sets: [],
        sku_list: [],
      },

      //领取人员表头
      userColumns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
        },
        {
          title: "购买人",
          dataIndex: "user_name",
          width: "150px",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "name",
          },
        },
        {
          title: "状态",
          width: "100px",
          dataIndex: "status",
          scopedSlots: {
            customRender: "status2",
          },
          filterMultiple: false,
        },
        {
          title: "下单时间",
          width: "150px",
          dataIndex: "create_time_str",
          scopedSlots: {
            customRender: "create_time_str",
          },
        },
        {
          title: "查看订单",
          width: "100px",
          dataIndex: "order2",
          scopedSlots: {
            customRender: "order2",
          },
        },
      ],
      userPagination: {},
      userQuery: {
        sale_id: 0,
        status: 0,
        page: 1,
        keywords: undefined,
      },
      goodsPagination: {},
      goodsQuery: {
        sale_id: 0,
        status: 0,
        page: 1,
        keywords: undefined,
      },
      saleUserList: [],
      sku_show: false,
    };
  },
  computed: {},
  created() {
    this.getGoodsOptions();
  },
  mounted() {
    let that = this;
  },
  methods: {
    moment,
    handleUrl() {
      let { href } = this.$router.resolve({
        name: "GoodsForm",
        query: { id: this.goodsData.goods_id },
      });
      // this.$router.push({
      //     name: 'GoodsForm', query: {id: this.goodsData.goods_id}
      //   })
      window.open(href, "_blank");
    },
    onDelete(record) {
      let self = this;
      console.log(record);

      saleGoodsDelete({ id: record.id })
        .then((res) => {
          self.$message.success("删除成功");
          self.fetchGoodsList();
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },

    handleOrderEdit(record) {
      let self = this;
      this.orderAddVisible = true;
      this.getGoodsOptions();

      saleGoodsDetail({ id: record.id }).then((res) => {
        setTimeout(() => {
          self.form.setFieldsValue({ ...res.data });
        });
        self.goodsData = res.data;
        self.goodsData.id = res.data.id;
        self.goodsData.goods_id = res.data.goods_id;
        self.goodsChange(res.data.goods_id);
      });
    },

    handleGoodsOk(e) {
      let self = this;
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log("Received valuess of formData: ", self.goodsData);
          let goods_form = Object.assign(self.goodsData, values);
          if (goods_form.id) {
            saleGoodsEdit(goods_form)
              .then((res) => {
                self.$message.success("修改成功");
                self.orderAddVisible = false;
                self.saveLoading = false;
                self.fetchGoodsList();
              })
              .catch((err) => {
                self.$message.error(err.msg);
                self.saveLoading = false;
              });
          } else {
            saleGoodsAdd(goods_form)
              .then((res) => {
                self.$message.success("新增成功");
                self.orderAddVisible = false;
                self.saveLoading = false;
                self.fetchGoodsList();
              })
              .catch((err) => {
                self.$message.error(err.msg);
                self.saveLoading = false;
              });
          }
        }
      });
    },
    fetchGoodsList() {
      let self = this;
      console.log("fetchGoodsList");
      saleGoodsList(Object.assign(self.goodsQuery, self.goodsPagination)).then(
        (res) => {
          self.orderData = res.data.list;
          const pagination = { ...this.goodsPagination };
          pagination.total = res.data.total;
          self.goodsPagination = pagination;
        }
      );
    },
    handleGoodsCancel() {
      this.orderAddVisible = false;
    },
    //添加商品
    handleOrderAdd() {
      this.form.resetFields();
      this.goodsData.goods_id = "";
      this.goodsData.id = 0;
      this.goodsData.goods_name = "";
      this.goodsData.sku_name = "";
      this.goodsData.sku_id = "";
      this.goodsData.goods_count = 0;
      this.goodsData.goods_price = 0;
      this.goodsData.express_free_status = false;
      this.orderAddVisible = true;
    },
    //商品清单
    handleOrderList(record) {
      this.goodsData.sale_id = record.id;
      this.orderVisible = true;
      let self = this;
      self.goodsQuery.sale_id = record.id;
      self.goodsQuery.keywords = undefined;
      self.goodsQuery.status = undefined;
      self.goodsPagination.page = 1;
      self.fetchGoodsList();
    },
    handleCancel() {
      this.visible = false;
    },
    // 增
    handleAdd() {
      let that = this;
      this.visible = true;
      this.form.resetFields();
      this.formData = {
        id: 0,
        title: "",
        areas: [],
        express_user_name: "",
        express_user_phone: "",
        express_province: "",
        express_city: "",
        express_county: "",
        address: "",
        time_range_moment: [],
        time_range: [],
        complete_count: 1,
        time_limit: 24, 
        recommend_user_id:'',
        recommend_user_name:'',
        auto_complete: true,
        status: true,
        express_free_status: false,
      };
      setTimeout(() => {
        that.form.setFieldsValue({ ...this.formData });
      });
    },
    //分享
    handleShare(record) {
      let that = this;
      that.h5ShareVisible = true;
      that.share.site_url = record.h5_url;
      that.share.wxmini_pic_url = record.h5_pic_url;
    },
    onCopy(e) {
      this.$message.success("复制成功");
    },
    onError(e) {
      this.$message.error("复制失败");
    },

    // 改
    handleEdit(record) {
      let self = this;
      saleDetail({ id: record.id }).then((res) => {
        self.form.setFieldsValue({ ...res.data });
        self.formData.id = record.id;
        self.formData.title = res.data.title;

        self.formData.recommend_user_name = res.data.recommend_user_name;
        self.formData.recommend_user_id = res.data.recommend_user_id;
        self.formData.time_range_moment = [
          moment(res.data.time_start * 1000),
          moment(res.data.time_end * 1000),
        ];
        self.formData.auto_complete =
          res.data.auto_complete == 1 ? true : false;
        self.formData.status = res.data.status == 2 ? false : true;
        self.formData.express_free_status =
          res.data.express_free_status == 2 ? false : true;
        self.formData.areas = res.data.areas;
      });
      // console.log(this.mdl)
      this.visible = true;
    },

    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault();

      if (self.formData.time_range_moment.length != 2) {
        self.$message.error("请选择时间范围");
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log(Object.assign(self.formData, values));
          let formdata = Object.assign(self.formData, values);
          formdata.status = self.formData.status ? 1 : 2;
          formdata.express_free_status = self.formData.express_free_status
            ? 1
            : 2;
          formdata.time_range = [
            self.formData.time_range_moment[0].format("YYYY-MM-DD HH:mm:ss"),
            self.formData.time_range_moment[1].format("YYYY-MM-DD HH:mm:ss"),
          ];
          formdata.time_range_moment = [];
          self.saveLoading = true;
          if (formdata.id) {
            editSale(formdata)
              .then((res) => {
                self.$message.success("修改成功");
                self.$refs.table.refresh(false);
                self.visible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.msg);
                self.saveLoading = false;
              });
          } else {
            addSale(formdata)
              .then((res) => {
                self.$message.success("新增成功");
                self.$refs.table.refresh(false);
                self.visible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.msg);
                self.saveLoading = false;
              });
          }
        }
      });
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false);
    },
    setAllStatus(status) {
      let self = this;
      setTuanAllStatus({
        ids: self.selectedRowKeys,
        status: status,
      }).then((res) => {
        self.$message.success("设置成功");
        self.$refs.table.refresh(false);
      });
    },
    setStatus(goods_id, status) {
      setGoodsStatus({
        id: goods_id,
        status: status,
      }).then((res) => {
        self.$message.success("设置成功");
        self.$refs.table.refresh(false);
      });
    },
    // 删
    deleteHandle(record) {
      let self = this;
      saleDelete({ id: record.id })
        .then((res) => {
          self.$message.success("删除成功");
          self.$refs.table.refresh(false);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
    onRankChange(key, dataIndex, value) {
      let self = this;
      setTuanRank({
        id: key,
        rank: value,
      })
        .then((res) => {
          self.$refs.table.refresh(false);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    getGoodsOptions() {
      let self = this;
      getGoodsOptions()
        .then((res) => {
          self.goodsOptions = res.data;
        })
        .catch((err) => {
          self.$message.error(err.msg);
        });
    },

    handleOrderDetail(record) {
      let { href } = this.$router.resolve({
        name: "OrderDetail",
        query: { id: record.order_id },
      });
      window.open(href, "_blank");
    },

    handleUserManage(record) {
      let self = this;
      self.userQuery.sale_id = record.id;
      self.userQuery.keywords = undefined;
      self.userQuery.status = undefined;
      self.userPagination.page = 1;
      self.fetchUserList();
      this.userVisible = true;
    },

    fetchUserList() {
      let self = this;
      getSaleUserList(Object.assign(self.userQuery, self.userPagination)).then(
        (res) => {
          self.saleUserList = res.data.list;
          self.userPagination.total = res.data.total;
        }
      );
    },

    userSearch(selectedKeys, confirm) {
      let self = this;
      confirm();
      self.fetchUserList();
    },
    userSearchReset(selectedKeys, confirm) {
      let self = this;
      confirm();
      self.userQuery.keywords = undefined;
      self.fetchUserList();
    },
    handleUserTableChange(pagination, filters, sorter) {
      console.log("filters", filters);
      let that = this;
      if (filters.status) {
        that.userQuery.status = filters.status[0];
      } else {
        that.userQuery.status = 0;
      }
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      that.pagination = pager;
      that.userQuery.page = pagination.current;
      that.fetchUserList();
    },
    onSkuChecked(value) {
      console.log(value);
      this.goodsData.sku_id = value.sku_id;
      this.goodsData.sku_name = value.sku_name;
      this.goodsData.goods_price = parseInt(value.goods_price);
    },
    goodsChange(goods_id) {
      console.log(goods_id);
      this.sku_show = false;
      this.goodsData.sku_id = 0;
      this.goodsData.sku_name = '';
      if (!goods_id) {
        return [];
      }
      let that = this;
      getGoodsSkuDetail({ goods_id: goods_id })
        .then((res) => {
          this.sku_show = true;
          this.goodsData.goods_name = res.data.goods_title;
          this.goods_sku = res.data;
          this.goods_sku.sku_fields_list.map((item, i) => {
            item.attrs.map((sku, s) => {
              sku["check"] = false;
            });
          });
        })
        .catch((err) => {
          that.$message.error(err.data.msg);
        });
    },
    
    onAreaChange(value, selectedOptions) {
      if (selectedOptions.length == 3) {
        this.formData.express_province = selectedOptions[0].label;
        this.formData.express_city = selectedOptions[1].label;
        this.formData.express_county = selectedOptions[2].label;
      } else if (selectedOptions.length == 2) {
        this.formData.express_province = selectedOptions[0].label;
        this.formData.express_city = selectedOptions[1].label;
      } else {
        this.formData.express_province = selectedOptions[0].label;
      }
    },
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  },
};
</script>


<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
